import templateStr from 'text!./account-billing.html';
import 'portalConfig';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            accountBillingSummary: '=',
            accountBillingData: '=',
            accountBillingAddress: '=',
            accountLoaded: '=',
            accountNumber: '@'
        },
        controller: ['$scope', function ($scope) {
            if ($scope.accountBillingSummary) {
                $scope.displayAddressArray = $scope.accountBillingSummary.primaryPayer.address.split(', ');
                $scope.accountBillingSummary.primaryPayer.addressLine1 = $scope.displayAddressArray[0];
                $scope.accountBillingSummary.primaryPayer.addressLine2 = $scope.displayAddressArray[1];
                $scope.accountBillingSummary.primaryPayer.addressLine3 = $scope.displayAddressArray[2];
                $scope.accountBillingSummary.primaryPayer.addressLine4 = $scope.displayAddressArray[3];
                $scope.accountBillingSummary.primaryPayer.addressLine5 = $scope.displayAddressArray[4];
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/AccountBillingDirective/AccountBilling.js
// module id = 1721
// module chunks = 0